const nasobilkaDeviti = () => {
	return [
		{
			id: 1,
			priklad: '9 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '45',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '27',
				},
				{
					id: 4,
					moznost: '18',
				},
			],
			vysledek: '27',
		},
		{
			id: 2,
			priklad: '1 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '36',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '27',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '9',
		},
		{
			id: 3,
			priklad: '5 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '63',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '54',
				},
				{
					id: 4,
					moznost: '45',
				},
			],
			vysledek: '45',
		},
		{
			id: 4,
			priklad: '9 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '90',
				},
				{
					id: 2,
					moznost: '81',
				},
				{
					id: 3,
					moznost: '63',
				},
				{
					id: 4,
					moznost: '72',
				},
			],
			vysledek: '81',
		},
		{
			id: 5,
			priklad: '5 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '45',
				},
				{
					id: 2,
					moznost: '54',
				},
				{
					id: 3,
					moznost: '36',
				},
				{
					id: 4,
					moznost: '27',
				},
			],
			vysledek: '45',
		},
		{
			id: 6,
			priklad: '9 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '36',
				},
				{
					id: 2,
					moznost: '63',
				},
				{
					id: 3,
					moznost: '45',
				},
				{
					id: 4,
					moznost: '54',
				},
			],
			vysledek: '54',
		},
		{
			id: 7,
			priklad: '8 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '90',
				},
				{
					id: 2,
					moznost: '63',
				},
				{
					id: 3,
					moznost: '72',
				},
				{
					id: 4,
					moznost: '81',
				},
			],
			vysledek: '72',
		},
		{
			id: 8,
			priklad: '1 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '27',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '9',
		},
		{
			id: 9,
			priklad: '3 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '27',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '54',
				},
				{
					id: 4,
					moznost: '45',
				},
			],
			vysledek: '27',
		},
		{
			id: 10,
			priklad: '9 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '72',
				},
				{
					id: 2,
					moznost: '90',
				},
				{
					id: 3,
					moznost: '81',
				},
				{
					id: 4,
					moznost: '63',
				},
			],
			vysledek: '90',
		},
		{
			id: 11,
			priklad: '27 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '3',
		},
		{
			id: 12,
			priklad: '63 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '7',
		},
		{
			id: 13,
			priklad: '18 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '3',
				},
				{
					id: 4,
					moznost: '1',
				},
			],
			vysledek: '2',
		},
		{
			id: 14,
			priklad: '36 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '4',
		},
		{
			id: 15,
			priklad: '72 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '8',
		},
		{
			id: 16,
			priklad: '90 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '10',
		},
		{
			id: 17,
			priklad: '81 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '9',
		},
		{
			id: 18,
			priklad: '72 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '8',
		},
		{
			id: 19,
			priklad: '63 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '7',
		},
		{
			id: 20,
			priklad: '0 : 9',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '1',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '0',
				},
			],
			vysledek: '0',
		},
		{
			id: 21,
			priklad: '9 x 1',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '27',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '1',
				},
			],
			vysledek: '9',
		},
		{
			id: 22,
			priklad: '9 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '63',
				},
				{
					id: 2,
					moznost: '54',
				},
				{
					id: 3,
					moznost: '45',
				},
				{
					id: 4,
					moznost: '36',
				},
			],
			vysledek: '45',
		},
		{
			id: 23,
			priklad: '6 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '36',
				},
				{
					id: 2,
					moznost: '54',
				},
				{
					id: 3,
					moznost: '45',
				},
				{
					id: 4,
					moznost: '63',
				},
			],
			vysledek: '54',
		},
		{
			id: 24,
			priklad: '9 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '72',
				},
				{
					id: 2,
					moznost: '45',
				},
				{
					id: 3,
					moznost: '54',
				},
				{
					id: 4,
					moznost: '63',
				},
			],
			vysledek: '72',
		},
	];
};

export default nasobilkaDeviti;
